import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import * as messageConstants from '../../../shared/messages';

import './OidcIdpMetadataPopup.scss';

class OidcIdpMetadataPopup extends Component {
  state = {
    copiedOidcMetadataUrl: false,
    copiedOidcIssuerUrl: false,
    copiedAuthorizeEndpointUrl: false,
    copiedTokenEndpointUrl: false,
    copiedUserInfoEndpointUrl: false,
    copiedIntrospectionEndpointUrl: false,
    copiedLogoutEndpointUrl: false,
    downloadCertificate: false,
  }

  handleCopyText = (event) => {
    const textItem = event.currentTarget.id;
    const copied = {};

    copied[textItem] = true;
    this.setState(copied);
  }
  handleCopyTextClear = (event) => {
    const textItem = event.currentTarget.id;
    const copied = {};

    copied[textItem] = false;
    this.setState(copied);
  }
  handleDownloadCertificate = () => {

    const fileData = [this.props.idpMetadata.publicKeyPemCertificate];
    const fileName = "Imprivata IDP certificate.cer";
    if (window.navigator.msSaveOrOpenBlob) {
      let blobObject = new Blob(fileData);
      window.navigator.msSaveOrOpenBlob(blobObject, fileName);
    }
    else {
      let blob = new Blob(fileData, {type: 'text/plain;charset=utf-8;'});
      let $link = document.createElement("a");
      let url = URL.createObjectURL(blob);
      $link.setAttribute("target", "_blank");
      $link.setAttribute("href", url);
      $link.setAttribute("download", fileName);
      $link.style.visibility = "hidden";
      document.body.appendChild($link);
      $link.click();
      document.body.removeChild($link);
    }
  }
  handleHideModalOidcIdpMetadata = () => {
    this.setState({
      copiedOidcMetadataUrl: false,
      copiedOidcIssuerUrl: false,
      copiedAuthorizeEndpointUrl: false,
      copiedTokenEndpointUrl: false,
      copiedUserInfoEndpointUrl: false,
      copiedIntrospectionEndpointUrl: false,
      copiedLogoutEndpointUrl: false,
      downloadCertificate: false,
    });
    this.props.handleHideModalOidcIdpMetadata();
  }

  componentDidUpdate() {
    if (this.props.errorMsg) {
      this.props.handleHideModalOidcIdpMetadata();
    }
  }

  render() {
    const {
      idpMetadata
    } = this.props;

    const orBlock = <div className="line"><span
        className="or">{messageConstants.OR}</span></div>;
    return (
        <div className="oidc-idp-metadata-container">
          <Modal
              id="idpMetadataModal"
              show={this.props.showModalOidcIdpMetadata}
              onHide={this.handleHideModalOidcIdpMetadata}
              container={this}
              aria-labelledby="contained-modal-title"
              dialogClassName="idp-metadata-modal"
          >

            <Modal.Header
                className="basic-modal-header"
            >
              <Modal.Title>
                <span
                    className="basic-modal-header-title">{messageConstants.OIDC_IDP_METADATA}
                </span>
                <button className="entity-id-modal-close"
                        type="button"
                        onClick={this.handleHideModalOidcIdpMetadata}/>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body
                className="idp-metadata-modal-body">
              <div
                  className="import-modal-body-top">{messageConstants.IDP_METHODS_TEXT_USE}<b>{messageConstants.IDP_METHODS_TEXT_ONE}</b>{messageConstants.IDP_METHODS_TEXT_END}
              </div>

              <dl className="manual-idp-list">
                <dt
                    className="entry-label">{messageConstants.IDP_METADATA_URL}</dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="idpIssuerUrlValue">
                      {idpMetadata.oidcMetadataUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.oidcMetadataUrl}
                      >
                        {
                          this.state.copiedOidcMetadataUrl ? (
                              <input id="copiedOidcMetadataUrl"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedOidcMetadataUrl"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>
              </dl>
              {orBlock}
              <dl className="manual-idp-list">
                <dt className="entry-label">
                  {messageConstants.ISSUER_URL}
                </dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="oidcIssuerUrlValue">
                      {idpMetadata.oidcIssuerUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.oidcIssuerUrl}
                      >
                        {
                          this.state.copiedOidcIssuerUrl ? (
                              <input id="copiedOidcIssuerUrl"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedOidcIssuerUrl"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>

                <dt className="entry-label">
                  {messageConstants.AUTHORIZE_ENDPOINT_URL}
                </dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="authorizeEndpointValue">
                      {idpMetadata.oidcAuthorizeEndpointUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.oidcAuthorizeEndpointUrl}
                      >
                        {
                          this.state.copiedAuthorizeEndpointUrl ? (
                              <input id="copiedAuthorizeEndpointUrl"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedAuthorizeEndpointUrl"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>

                <dt className="entry-label">
                  {messageConstants.TOKEN_ENDPOINT_URL}
                </dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="tokenEndpointValue">
                      {idpMetadata.oidcTokenEndpointUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.oidcTokenEndpointUrl}
                      >
                        {
                          this.state.copiedTokenEndpointUrl ? (

                              <input id="copiedTokenEndpointUrl"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedTokenEndpointUrl"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>

                <dt className="entry-label">
                  {messageConstants.USER_INFO_ENDPOINT_URL}
                </dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="userInfoEndpointValue">
                      {idpMetadata.oidcUserInfoEndpointUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.oidcUserInfoEndpointUrl}
                      >
                        {
                          this.state.copiedUserInfoEndpointUrl ? (

                              <input id="copiedUserInfoEndpointUrl"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>

                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedUserInfoEndpointUrl"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>

                {idpMetadata.oidcIntrospectionEndpointUrl ? (
                    <div>
                      <dt className="entry-label">
                        {messageConstants.INTROSPECTION_ENDPOINT_URL}
                      </dt>
                      <dd>
                        <div className="copy-row">
                          <div className="entry-value"
                               id="introspectionEndpointValue">
                            {idpMetadata.oidcIntrospectionEndpointUrl}
                          </div>
                          <div className="copy-link">
                            <CopyToClipboard
                                text={idpMetadata.oidcIntrospectionEndpointUrl}
                            >
                              {
                                this.state.copiedIntrospectionEndpointUrl ? (

                                    <input id="copiedIntrospectionEndpointUrl"
                                           onClick={this.handleCopyTextClear}
                                           type="button"
                                           value={messageConstants.COPIED}
                                           className="button_check"/>
                                ) : (
                                    <button
                                        title={messageConstants.COPY}
                                        id="copiedIntrospectionEndpointUrl"
                                        className="btn btn-link"
                                        onClick={this.handleCopyText}
                                    >
                                      <i className="copy-mark"/>
                                    </button>
                                )
                              }
                            </CopyToClipboard>
                          </div>
                        </div>
                      </dd>
                    </div>
                ) : null}

                {idpMetadata.oidcLogoutEndpointUrl ? (
                    <div>
                      <dt className="entry-label">
                        {messageConstants.LOGOUT_URL}
                      </dt>
                      <dd>
                        <div className="copy-row">
                          <div className="entry-value"
                               id="logoutEndpointValue">
                            {idpMetadata.oidcLogoutEndpointUrl}
                          </div>
                          <div className="copy-link">
                            <CopyToClipboard
                                text={idpMetadata.oidcLogoutEndpointUrl}
                            >
                              {
                                this.state.copiedLogoutEndpointUrl ? (

                                    <input id="copiedLogoutEndpointUrl"
                                           onClick={this.handleCopyTextClear}
                                           type="button"
                                           value={messageConstants.COPIED}
                                           className="button_check"/>
                                ) : (
                                    <button
                                        title={messageConstants.COPY}
                                        id="copiedLogoutEndpointUrl"
                                        className="btn btn-link"
                                        onClick={this.handleCopyText}
                                    >
                                      <i className="copy-mark"/>
                                    </button>
                                )
                              }
                            </CopyToClipboard>
                          </div>
                        </div>
                      </dd>
                    </div>
                ) : null}

                <dd className="copy-row idp-metadata-xml">
                  <div className="entry-value">
                    {messageConstants.IDP_METHOD_CERTIFICATE}
                  </div>
                  <div className="copy-link">
                    <button
                        title={messageConstants.DOWNLOAD}
                        id="downloadIdpCertificateButton"
                        className="btn btn-link"
                        onClick={this.handleDownloadCertificate}
                    >
                      <i className="download-mark"/>
                    </button>
                  </div>
                </dd>
              </dl>
            </Modal.Body>
          </Modal>
        </div>
    );
  }

}

export default OidcIdpMetadataPopup;
